import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { Notification } from '../../../common/notification'
import { ScrollComponent } from '../../../common/scrollComponent'
import TextEllipsis from '../../../common/textEllipsis'
import { selectLoading } from '../store/slice'
import classes from './index.module.scss'

export const CompanyList = ({ term, data, onChooseSubject }) => {
  const isLoading = useSelector(selectLoading('searchSubject'))

  return (
    <ScrollComponent autoHeight autoHeightMax={200} autoHeightMin={30}>
      {isLoading ? (
        <Loading />
      ) : !data.length ? (
        <Notification />
      ) : (
        data.map((item, index) => (
          <ListItem
            key={index}
            index={index}
            term={term}
            item={item}
            onClick={onChooseSubject}
          />
        ))
      )}
    </ScrollComponent>
  )
}

const ListItem = ({ index, term, item, onClick }) => {
  const [isHovered, setIsHovered] = useState(false)

  const getText = () => {
    let text = [item.taxCode, item.ticker, item.organizationName]
      .filter(Boolean)
      .join(' - ')
    if (term) {
      const regex = new RegExp(term, 'gi')
      text = text.replaceAll(regex, (str) => `<b>${str}</b>`)
    }
    return <span dangerouslySetInnerHTML={{ __html: text }} />
  }

  const handleClick = () => {
    onClick(index)
  }

  const onMouseOver = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  return (
    <Element
      onClick={handleClick}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      className={classes.listItem}
      style={{
        color: '#3A414B',
        backgroundColor: isHovered ? '#C8E3FF' : 'transparent',
      }}
    >
      <TextEllipsis text={getText()} isI18n={false} zIndexTooltip={13} />
    </Element>
  )
}
